import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Wix from '../../../services/wix-sdk-polyfill';
import TextEditorButton from '../text-editor-button';
import normalizeImageData from './normalize-image-data';

export default function createMediaDialogButton({ className, displayName, content: Content, tooltipText }) {
  return class extends Component {
    static displayName = displayName;
    static propTypes = {
      onFileSelect: PropTypes.func,
    };

    handleClick = () =>
      Wix.Settings.openMediaDialog(Wix.Settings.MediaType.IMAGE, false, imageData =>
        this.props.onFileSelect(normalizeImageData(imageData))
      );

    render() {
      return (
        <TextEditorButton
          className={className}
          icon={Content}
          tooltipText={tooltipText}
          onClick={this.handleClick}
          {...this.props}
        />
      );
    }
  };
}



// WEBPACK FOOTER //
// ./app/components/text-editor/utils/create-media-dialog-button.js